import {
    Apple,
    Baby,
    Cookie,
    CupSoda,
    Home,
    Leaf,
    Milk,
    Package,
    PawPrint,
    Pill,
    Sandwich,
    Snowflake,
    Sparkles,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/**
 * String → Lucide icon component map.
 * The backend stores the icon *name*, keeping it framework-agnostic.
 */
const ICON_MAP: Record<string, LucideIcon> = {
    Apple,
    Baby,
    Cookie,
    CupSoda,
    Home,
    Leaf,
    Milk,
    PawPrint,
    Pill,
    Sandwich,
    Snowflake,
    Sparkles,
};

export function resolveCategoryIcon(name: string): LucideIcon {
    return ICON_MAP[name] ?? Package;
}
